import { MemberInvoiceRequest } from 'src/modules/member/models/memberInvoiceRequest';
import AxiosInstance from './axios/interceptor';

const controller = 'MemberInvoice';

export const createMemberInvoice = (data: MemberInvoiceRequest) => {
  return AxiosInstance.post(controller, data);
};
